<template>
  <div v-if="!closed" class="age_disclaimer_bg" ref="bg">
  <div  class="age_disclaimer">
    <div class="h4">18+</div>
    <p>Сайт содержит информацию для лиц совершеннолетнего возраста. Сведения, размещённые на&nbsp;сайте, не&nbsp;являются рекламой, носят информационный характер и&nbsp;предназначены только для&nbsp;личного пользования.</p>
    <div class="accept_button">
      <AppButton type="black" size="xs" text="Мне исполнилось 18 лет"  @click="close()"></AppButton>
    </div>
  </div>
  </div>
</template>
<script setup lang="ts">
import {useCookie} from "nuxt/app";
import AppButton from "@components/AppButton/index.vue"
import IconDefault from "@components/AppIcon/index.vue"
defineOptions({
  name: 'AgeDisclaimer'
})
const closed = useCookie('age_disclaimer_closed')

function close() {
  closed.value = '1'
}
</script>
<style scoped lang="scss">
.age_disclaimer_bg{
  position: fixed;
  overflow: hidden;
  top:0;
  left:0;
  width: 100%;
  height: 100%;
  z-index: var(--z-index-age-disclaimer);
  backdrop-filter: blur(2rem);
  display: flex;
  align-items: center;
  justify-content: center;
}
.age_disclaimer{
  width: 38.8rem;
  text-align: center;
  background: #fff;
  border-radius: var(--space-24);
  color: var(--color-black);
  padding: var(--space-24);
  @media screen and (max-width: 768px){
    width: 90%;
  }
  .accept_button{
    display: flex;
    align-items: center;
    justify-content: center;
  }

}
</style>